<template>
  <v-main>
    <Chat />
  </v-main>
</template>

<script>
import Chat from '@/components/chat'
export default {
  name: 'view-chat',
  components: { Chat }
}
</script>

<style scoped>
</style>
